import {IMapOffer} from "../../maps/types/IMapOffer";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

export const transformRelatedOfferIntoMapOffer = (offer: IRelatedOfferList): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60),
    description: `Liczba mieszkań: ${offer.properties}`,
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 375, 211),
        mobile: getThumbnailLink(offer.main_image_url, 155, 87)
    },
    distance: offer.stats?.distance_from_region.distance,
    region: {
        country: offer.region.country
    }
});
import {IMapOffer} from "../../maps/types/IMapOffer";
import {getThumbnailLink} from "../../utils/get_thumbnail_link";
import {IRelatedOfferList} from "../list/types/IOfferListResponse";

export const transformRelatedOfferIntoMapOffer = (offer: IRelatedOfferList): IMapOffer => ({
    id: offer.id,
    name: offer.name,
    coordinates: offer.geo_point.coordinates,
    vendorName: offer.vendor.name,
    vendorLogo: getThumbnailLink(offer.vendor.logo_url, 80, 60),
    description: `Liczba mieszkań: ${offer.properties}`,
    mainImage: {
        desktop: getThumbnailLink(offer.main_image_url, 375, 211),
        mobile: getThumbnailLink(offer.main_image_url, 155, 87)
    },
    distance: offer.stats?.distance_from_region.distance,
    region: {
        country: offer.region.country
    }
});
